/*jshint esversion: 11 */

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';


/**
 * Carrossel de eventos. Com `moreUrl` (busca), os cards seguintes são pedidos ao chegar no fim e acrescentados ao carrossel;
 * a resposta traz `<!--next:N-->` com o próximo deslocamento (vazio quando acabou) e um X-Page-Token novo.
 */
window.eventswp = (options) => {
    "use strict";
    const config = options || {};
    return {
        swiper: null,
        moreUrl: config.moreUrl || null,
        token: config.token || null,
        loading: false,
        async loadMore() {
            if (!this.moreUrl || this.loading) {
                return;
            }

            this.loading = true;

            try {
                const response = await fetch(this.moreUrl, {credentials: 'omit', headers: {Accept: 'text/html', 'X-Page-Token': this.token || ''}});
                this.token = response.headers.get('X-Page-Token') || this.token;

                if ([204, 403, 404].includes(response.status)) {
                    this.moreUrl = null; // vazio, token vencido ou URL inválida: para em vez de insistir

                    return;
                }

                if (!response.ok) {
                    return; // 429/5xx momentâneo: mantém a URL e tenta de novo no próximo reachEnd
                }

                const html = await response.text();
                const next = (html.match(/<!--next:(\d*)-->/) || [])[1];
                // appendSlide com string insere texto; com elementos, slides de verdade.
                const template = document.createElement('template');
                template.innerHTML = html.replace(/<!--next:\d*-->/, '');
                this.swiper.appendSlide([...template.content.children]);

                if (next) {
                    const url = new URL(this.moreUrl, window.location.origin);
                    url.searchParams.set('offset', next);
                    this.moreUrl = url.pathname + url.search;
                } else {
                    this.moreUrl = null;
                }
            } catch (error) {
                // falha de rede: tenta de novo na próxima vez que o usuário chegar ao fim
            } finally {
                this.loading = false;
            }
        },
        init() {
            this.swiper = new Swiper(this.$refs.swpContainer, {
                slidesPerView: "auto",
                spaceBetween: 10,
                a11y: {
                    slideLabelMessage: "",
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: this.$refs.nextButton,
                    prevEl: this.$refs.prevButton,
                },
            });

            if (this.moreUrl) {
                this.swiper.on('reachEnd', () => this.loadMore());
            }

            this.swiper.on('activeIndexChange', () => {
                if (window.innerWidth > 768) {
                    this.$refs.prevContainer.classList.toggle('hidden', this.swiper.isBeginning);
                }
            });
        }
    };
};
